import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;
  return (
    <DaylightSection
      className={props.parentClass}
      containerWidth="wide"
      id={props.anchorId}
      spacing={props.spacing}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </DaylightSection>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
